import { fromJS } from 'immutable';
import codingActions from '../constants';
import scoreActions from '../../scores/constants';

const initialState = fromJS({});

export default (state = initialState, action) => {
  switch (action.type) {
    case codingActions.CREATE_FINISH:
      return state.set('lastAction', fromJS({ type: 'coding', id: action.payload.id}));
    case scoreActions.CREATE_FINISH:
      return state.set('lastAction', fromJS({ type: 'score', id: action.payload.id}));
    case codingActions.DELETE_FINISH:
      return state.getIn(['lastAction', 'type']) === 'coding' ? state.delete('lastAction') : state;
    case scoreActions.DELETE_FINISH:
      return state.getIn(['lastAction', 'type']) === 'score' ? state.delete('lastAction') : state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/coding/reducers/ui.js